import React from "react";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import MenuItem from "./MenuItem";
import DoorSlidingIcon from "@mui/icons-material/DoorSliding";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import { Box, Button, Typography } from "@mui/material";

import aal_operator_logo from "../../../assets/images/aal_operator.png";
import owner_logo from "../../../assets/images/owner.png";
import default_logo from "../../../assets/images/default.png";
import fulltech_logo from "../../../assets/images/fulltech.png";
import haudi_logo from "../../../assets/images/haudi.png";
import sci_operator_logo from "../../../assets/images/sci_operator.png";

// Amplify
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";

import { AppVariants } from "../../../common/AppVariants";
import { CloudUpload } from "@mui/icons-material";

interface DrawerMenuProps {
  container?: () => HTMLElement;
  open: boolean;
  onClose: () => void;
  width: number;
  appVariant: AppVariants;
}

const DrawerMenu: React.FC<DrawerMenuProps> = ({
  container,
  open,
  onClose,
  width,
  appVariant,
}) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      // Amplify's signOut method
      await Auth.signOut();
      navigate(`/`);

      // Clear session and cookie
      sessionStorage.clear();
      document.cookie = "foobar=; max-age=0";
    } catch (error) {
      console.log("Error signing out: ", error);
    }
  };

  let logo = default_logo; // デフォルトのロゴを設定
  let drawerTitle = "管理アプリ";
  let menuItems;

  if (appVariant === AppVariants.AutolockOperator) {
    menuItems = (
      <List>
        <MenuItem
          icon={<ApartmentIcon />}
          text="管理物件一覧"
          linkTo="/buildings"
        />
      </List>
    );
    logo = aal_operator_logo;
  } else if (appVariant === AppVariants.Fulltech) {
    menuItems = (
      <List>
        <MenuItem
          icon={<ApartmentIcon />}
          text="物件一覧"
          linkTo="/buildings"
        />
        <MenuItem
          icon={<AccountBoxRoundedIcon />}
          text="LAD契約者一覧"
          linkTo="/owners"
        />
        <MenuItem icon={<DoorSlidingIcon />} text="SDC一覧" linkTo="/doors" />
      </List>
    );
    logo = fulltech_logo;
  } else if (appVariant === AppVariants.Owner) {
    menuItems = (
      <List>
        <MenuItem
          icon={<ApartmentIcon />}
          text="物件一覧"
          linkTo="/buildings"
        />
        <MenuItem
          icon={<AccountBoxRoundedIcon />}
          text="オペレーター一覧"
          linkTo="/operators"
        />
      </List>
    );
    logo = owner_logo;
  } else if (appVariant === AppVariants.SdcAdmin) {
    menuItems = (
      <List>
        <MenuItem icon={<DeveloperBoardIcon />} text="SDC一覧" linkTo="/sdcs" />
        <MenuItem icon={<CloudUpload />} text="OTA実行予約一覧" linkTo="/ota-schedules" />
      </List>
    );
    logo = haudi_logo;
  } else if (appVariant === AppVariants.SocialOperator) {
    menuItems = (
      <List>
        <MenuItem
          icon={<DeveloperBoardIcon />}
          text="管理物件一覧"
          linkTo="/buildings"
        />
      </List>
    );
    logo = sci_operator_logo;
  }

  return (
    <Drawer
      container={container}
      variant="temporary"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        display: "block",
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Toolbar sx={{ marginLeft: 1 }}>
        <img
          src={logo}
          alt="Logo"
          style={{ height: 24, marginRight: "0.5em" }}
        />
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, marginTop: 0.3 }}
        >
          {drawerTitle}
        </Typography>
      </Toolbar>
      <Divider />
      <Box sx={{ flexGrow: 1 }}>{menuItems}</Box>
      <Button onClick={handleSignOut} sx={{ marginBottom: 2 }}>
        サインアウト
      </Button>
    </Drawer>
  );
};

export default DrawerMenu;
